import React, { useEffect, useState, useRef } from 'react'

import { Card, CheckBox, Col, Grid, Input, Text, Line } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { ReportsRow, buildSetSize, getItemSize } from 'components/ReportsRow'
import { useWindowResize } from 'hooks'
import { VariableSizeList as List } from 'react-window'
import { SPACING } from 'utils'
import { TypesReports } from 'utils/types'

import { ListTypes } from '../ReportsAcess'

export interface CompanyCenter {
  getData: () => void
  centros: TypesReports[]
  empresas: TypesReports[]
  subcontratadas: TypesReports[]
  disableAll?: boolean
  handleChangeItem: (
    checked: boolean,
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id: number
  ) => void
  checkAll: (
    actionType: 'add' | 'remove' | 'checkAll' | 'unCheckAll',
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id?: number
  ) => void
  handleChangeInput: (value: string, t: ListTypes) => void
  empresa: string | undefined
  centro: string | undefined
  subcontratada: string | undefined
}

const CompanyCenter: React.FC<CompanyCenter> = ({
  centros,
  subcontratadas,
  getData,
  empresas,
  handleChangeItem,
  checkAll,
  centro,
  subcontratada,
  handleChangeInput,
  empresa,
  disableAll
}) => {
  const [allEmpresas, setAllEmpresas] = useState<boolean>(false)
  const [allCentros, setAllCentros] = useState<boolean>(false)
  const [allSubContratadas, setAllSubContratadas] = useState<boolean>(false)

  useEffect(() => {
    if (disableAll) {
      setAllEmpresas(false)
      setAllCentros(false)
      setAllSubContratadas(false)
      disableAll = false
    }
  }, [allEmpresas, allCentros, allSubContratadas, disableAll])

  const empresaSizeMap = useRef({})
  const empresaListRef = useRef(null)
  const empresaSetSize = buildSetSize(empresaSizeMap, empresaListRef)

  const centroSizeMap = useRef({})
  const centroListRef = useRef(null)
  const centroSetSize = buildSetSize(centroSizeMap, centroListRef)

  const subFornecedoresSizeMap = useRef({})
  const subFornecedoresListRef = useRef(null)
  const subFornecedoresSetSize = buildSetSize(
    subFornecedoresSizeMap,
    subFornecedoresListRef
  )

  const [windowWidth] = useWindowResize()

  return (
    <>
      <Grid
        gridCols="1fr 1fr 1fr"
        gridGap="1rem"
        margin="1rem 0 0 0"
        alignItems="center"
      >
        <Input
          label="Empresa"
          placeholder="Nome do Empresa"
          value={empresa}
          onChange={(e) => handleChangeInput(e.target.value, 'empresas')}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
        />
        <Input
          label="Centro"
          placeholder="Nome do Centro"
          value={centro}
          onChange={(e) => handleChangeInput(e.target.value, 'centros')}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
        />
        <Input
          label="Subcontratadas dos Fornecedores"
          placeholder="Nome da Subcontratada"
          value={subcontratada}
          onChange={(e) => handleChangeInput(e.target.value, 'subcontratadas')}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
        />
      </Grid>
      <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 1rem 0">
        <Col>
          <CheckBox
            checked={allEmpresas}
            label="Marcar Todos"
            onChange={(e) => {
              if (disableAll) setAllEmpresas(false)
              // eslint-disable-next-line no-unused-expressions
              e.target.checked
                ? (setAllEmpresas(true), checkAll('checkAll', 'empresa'))
                : (setAllEmpresas(false), checkAll('unCheckAll', 'empresa'))
            }}
            disabled={empresas?.length === 0}
          />

          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing20}
          >
            <Line />
            <List
              itemCount={empresas.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(empresaSizeMap, index)}
              ref={empresaListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={empresas[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={empresaSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'empresa',
                            empresas[index].id
                          )
                        }
                        checked={empresas[index].checked || false}
                        key={empresas[index].id}
                        label={empresas[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            checked={allCentros}
            label="Marcar Todos"
            onChange={(e) => {
              if (disableAll) setAllCentros(false)

              if (e.target.checked) {
                setAllCentros(true)
                checkAll('checkAll', 'centro')
              } else {
                setAllCentros(false)
                checkAll('unCheckAll', 'centro')
              }
            }}
            disabled={centros?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing20}
          >
            <Line />
            <List
              itemCount={centros.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(centroSizeMap, index)}
              ref={centroListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={centros[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={centroSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'centro',
                            centros[index].id
                          )
                        }
                        checked={centros[index].checked || false}
                        key={centros[index].id}
                        label={centros[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            checked={allSubContratadas}
            label="Marcar Todos"
            onChange={(e) => {
              if (disableAll) setAllSubContratadas(false)
              // eslint-disable-next-line no-unused-expressions
              e.target.checked
                ? (setAllSubContratadas(true),
                  checkAll('checkAll', 'subcontratadas'))
                : (setAllSubContratadas(false),
                  checkAll('unCheckAll', 'subcontratadas'))
            }}
            disabled={subcontratadas?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing20}
          >
            <Line />
            <List
              itemCount={subcontratadas.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(subFornecedoresSizeMap, index)
              }
              ref={subFornecedoresListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={subcontratadas[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={subFornecedoresSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'subcontratadas',
                            subcontratadas[index].id
                          )
                        }
                        checked={subcontratadas[index].checked || false}
                        key={subcontratadas[index].id}
                        label={subcontratadas[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
    </>
  )
}

export default CompanyCenter
